import React, { useState, useEffect, useCallback } from 'react'
import styled from '@emotion/styled'

import request from 'Request'

import { downloadText } from 'Helpers'
import { colors } from 'Constants'

import Link from 'Components/Link'
import Tab from './Tab'

const SubInfoHeader = styled('span')`
  font-weight: 500;
  color: ${colors.textLight};
`

export default () => {
  const downloadPatients = useCallback(async () => {
    // TODO: Handle error
    const response = await request.post('/reports/activity/patients')
    downloadText(
      response.headers['content-disposition'].split('filename=')[1],
      response.data
    )
  })

  const [statistics, setStatistics] = useState({
    patients: 'Loading...',
    activePatients: 'Loading...',
    inactivePatients: 'Loading...',
    newPatients: 'Loading...',
    groupPatients: {}
  })

  useEffect(async () => {
    const getPatientsPromise = request.get('/info/patients/count')
    const getActivePatientsPromise = request.get('/info/patients/countActive')
    const getNewPatientsPromise = request.get('/info/patients/countNew')
    const getPatientsByGroupPromise = request.get('/info/patients/countByGroup')

    setStatistics({
      patients: (await getPatientsPromise).data,
      activePatients: (await getActivePatientsPromise).data,
      inactivePatients:
        (await getPatientsPromise).data - (await getActivePatientsPromise).data,
      newPatients: (await getNewPatientsPromise).data,
      groupPatients: (await getPatientsByGroupPromise).data
    })
  }, [])

  return (
    <>
      <Tab.Container>
        <Tab.Tabs autoWidth={true}>
          <Tab.Tab header="Total Patients" value={statistics.patients}>
            <Link
              onClick={downloadPatients}
              style={{ textAlign: 'right', textDecoration: 'underline' }}
            >
              Download All Patients
            </Link>
          </Tab.Tab>
          <Tab.Tab
            header="Not Started Patients"
            value={statistics.inactivePatients}
          />
          <Tab.Tab
            header="Activated Patients"
            value={statistics.activePatients}
          />
          <Tab.Tab header="New Patients" value={statistics.newPatients} />
        </Tab.Tabs>
      </Tab.Container>
      <Tab.Container paddingBottom={true}>
        <Tab.Tabs>
          {Object.keys(statistics.groupPatients).map(item => (
            <Tab.Tab
              header={`Group: ${item}`}
              value={statistics.groupPatients[item].total}
              padding="20px 16px"
              fontSize={true}
              numFontSize="24px"
            >
              <p>
                <SubInfoHeader>Activated:</SubInfoHeader>{' '}
                {statistics.groupPatients[item].started}{' '}
              </p>
              <p>
                <SubInfoHeader>Not Started:</SubInfoHeader>{' '}
                {statistics.groupPatients[item].total -
                  statistics.groupPatients[item].started}{' '}
              </p>
            </Tab.Tab>
          ))}
        </Tab.Tabs>
      </Tab.Container>
    </>
  )
}
